<!-- パスワード変更 -->
<template>
  <b-modal
    centered
    title="パスワード変更 "
    header-bg-variant="info "
    header-text-variant="white"
    hide-footer
    v-model="isModalOpen"
    size="md"
    
    :no-close-on-backdrop="true"
    @shown="focusMyElement"
    tabindex="-1"
    >
    <template v-slot:default>
      <div>
        <!-- 入力欄 -->
        <div>
          <div class="WorkM_RequestInputGroup">
            <div class="WorkM_RequestInputGroup__Label WorkM_Label_Change_Password">ユーザーID</div>
            <div class="WorkM_RequestInputGroup__Input w-25">
              <b-input v-model="editData.shain_cd" readonly size="sm" tabindex="-1"></b-input>
            </div>
            <div class="WorkM_RequestInputGroup__ValidationError">{{ validation.shain_cd }}</div>
          </div>
          <div class="WorkM_RequestInputGroup mt-3">
            <div class="WorkM_RequestInputGroup__Label WorkM_Label_Change_Password">現在のパスワード</div>
            <div class="WorkM_RequestInputGroup__Input" ref="focusThis">
              <b-input v-model="editData.current_pw" type="password" autocomplete="new-password" size="sm"></b-input>
            </div>
            <div class="WorkM_RequestInputGroup__ValidationError">{{ validation.current_pw }}</div>
          </div>
          <div class="WorkM_RequestInputGroup mt-3">
            <div class="WorkM_RequestInputGroup__Label WorkM_Label_Change_Password">新しいパスワード</div>
            <div class="WorkM_RequestInputGroup__Input">
              <b-input v-model="editData.new_pw" type="password" autocomplete="new-password" size="sm"></b-input>
            </div>
            <div class="WorkM_RequestInputGroup__ValidationError">{{ validation.new_pw }}</div>
          </div>
          <div class="WorkM_RequestInputGroup mt-3">
            <div class="WorkM_RequestInputGroup__Label WorkM_Label_Change_Password">新しいパスワード(確認)</div>
            <div class="WorkM_RequestInputGroup__Input">
              <b-input v-model="editData.new_pw_check" type="password" autocomplete="new-password" size="sm"></b-input>
            </div>
            <div class="WorkM_RequestInputGroup__ValidationError">{{ validation.new_pw_check }}</div>
          </div>
        </div>
        <!-- ボタン -->
        <div class="mt-5">
          <div class="d-flex justify-content-between flex-row-reverse">
            <b-button variant="success" class="WorkM_Button" @click="clickUpdate()">変更</b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable */
import config from "../../const/config";

export default {
  name: "ChangeLoginPassword",
  props: {},
  data: function () {
    return {
      isModalOpen: false,
      //
      targetContractCode: null,
      targetUserId: null,
      //
      editData: {},
      validation: {},
    };
  },
  mounted: function () {
    this.targetContractCode = this.$store.getters.getContractCode;
    this.targetUserId = this.$store.getters.getUserId;
  },
  methods: {
    hideModal: function () {
      this.isModalOpen = false;
    },
    openModal: function () {
      this.isModalOpen = true;
      this.editData = this.getInitData();
      this.validation = this.getInitData();

      this.editData.shain_cd = this.targetUserId;
    },
    // 初期化データ
    getInitData: function () {
      return { shain_cd: "", current_pw: "", new_pw: "", new_pw_check: "" };
    },
    // 更新ボタン押下時
    clickUpdate: function () {
      if(this.passwordCheck()){
        return;
      }
      let message = "ログインパスワードを変更します。"
      + "<br>よろしいですか？"
      this.$confirm(message, "確認", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
        dangerouslyUseHTMLString: true,
        customClass:"editCheckModalWidthHeader"
      }).then(() => {
        this.updatePassword();
      });
    },
    // パスワード更新実行
    updatePassword: function () {
      let requestParam = {
        shainCd: this.editData.shain_cd,
        currentPw: this.editData.current_pw,
        newPw: this.editData.new_pw,
      };

      this.validation = this.getInitData();
      this.postData(config.URL.CHANGE_PASSWORD, requestParam)
        .then((response) => {
          if (response.result) {
            this.showAlertUpdateSuccess("パスワードを変更しました。", "パスワード変更");
            this.hideModal();
          } else {
            if(response.detail == null){
              this.showAlertError(response.message);
            }
            else{
              this.validation = response.detail;
            }
            //セットバリデーション
            // this.setValidationResult(response);
          }
        })
        .catch((e) => {
          this.showToastServerError(e);
        })
        .finally(() => {});
    },
    // 入力チェック結果をセットする
    setValidationResult: function (response) {
      if (response.validation == null) {
        return;
      }

      let setValidation = this.getInitData();
      //エラーメッセージをセット
      response.validation.forEach((element) => {
        setValidation[element.field] = element.message;
      });

      this.validation = setValidation;
    },
    passwordCheck: function(){
      let passwordCheckFlg = false;
      let nowPasswordMessage = "";
      let newPasswordMessage = "";
      let newPasswordCheckMessage = "";
      const MSG_ERR_PASSWORD_EMPTY = "パスワードを入力してください";
      const MSG_ERR_PASSWORD_NOT_SAME = "新しいパスワードと新しいパスワード(確認)が一致しません";
      if(!this.editData.current_pw){
        nowPasswordMessage = MSG_ERR_PASSWORD_EMPTY;
        passwordCheckFlg = true;
      }
      if(!this.editData.new_pw || !this.editData.new_pw_check){
        if(!this.editData.new_pw){
          newPasswordMessage = MSG_ERR_PASSWORD_EMPTY;
          passwordCheckFlg = true;
        }
        if(!this.editData.new_pw_check){
          newPasswordCheckMessage = MSG_ERR_PASSWORD_EMPTY;
          passwordCheckFlg = true;
        }
      }
      else{
        if(this.editData.new_pw != this.editData.new_pw_check){
          newPasswordCheckMessage = MSG_ERR_PASSWORD_NOT_SAME;
          passwordCheckFlg = true;
        }
      }
      this.validation = { shain_cd: "", current_pw: nowPasswordMessage, new_pw: newPasswordMessage, new_pw_check: newPasswordCheckMessage }
      return passwordCheckFlg;
    }, 
    focusMyElement(){
      console.debug("call focusMyElement");
      // document.getElementById('test').focus();
      // スマホ表示時にキーボードが一瞬表示され画面がちらつくため
      // this.$refs.focusThis.focus();
    }
  },
};
</script>
<style scoped>
.WorkM_Label_Change_Password{
  font-size: 0.85rem;
  font-weight: 700;
  margin: 0;
}
</style>
